// extracted by mini-css-extract-plugin
export default {"badge":"TabBadge__badge__lFDEu","isUnread":"TabBadge__isUnread__WylrV"};